import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../common/services/api.service";

@Component({
    selector: "app-disease",
    templateUrl: "./disease.component.html",
    styleUrls: ["./disease.component.scss"],
})
export class DiseaseComponent implements OnInit {
    diseases: any[] = [];

    constructor(private apiService: ApiService) {
        this.fillDiseases();
    }

    ngOnInit(): void {}

    fillDiseases() {
        this.apiService.getDiseases().subscribe((res : any) => {
            console.log(res);
            if(!res) return;
            this.diseases = res;
        });
    }
}
